import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
export const pushUserSymbolsPopup = ()=>pushModal(ModalType.USER_SYMBOLS_LEGEND, {
        wrapInModal: false
    });
